import { isPendingPaymentIntentStatus } from "@helpers/stripeErrors"
import type { PaymentIntent } from "@stripe/stripe-js"

// Waits between lookups: about two minutes in all, then the user is told to
// come back (a bank debit can take days, so there is no point polling longer).
const POLL_DELAYS_MS = [
  2_000, 3_000, 5_000, 8_000, 10_000, 15_000, 15_000, 15_000, 15_000, 15_000,
  15_000,
]

/**
 * Looks the PaymentIntent up until it is no longer pending and returns it, or
 * `undefined` once the delays run out or `signal` aborts. A failed lookup
 * counts as still pending: the next one may work.
 */
export async function pollPaymentIntent({
  delaysMs = POLL_DELAYS_MS,
  retrieve,
  signal,
}: {
  delaysMs?: number[]
  retrieve: () => Promise<PaymentIntent | undefined>
  signal: AbortSignal
}): Promise<PaymentIntent | undefined> {
  for (const delay of delaysMs) {
    await new Promise((resolve) => setTimeout(resolve, delay))

    if (signal.aborted) return undefined

    const intent = await retrieve().catch(() => undefined)

    if (signal.aborted) return undefined

    if (intent && !isPendingPaymentIntentStatus(intent.status)) return intent
  }

  return undefined
}
